import { render } from "./BatchEmptyState.vue?vue&type=template&id=142486d0&scoped=true"
import script from "./BatchEmptyState.vue?vue&type=script&lang=js"
export * from "./BatchEmptyState.vue?vue&type=script&lang=js"

import "./BatchEmptyState.vue?vue&type=style&index=0&id=142486d0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-142486d0"]])

export default __exports__